export default __webpack_public_path__ + "static/media/chevron.e2577b63.svg";